import clsx from 'clsx'
import React from 'react'

import s from './styles.module.scss'

interface DividerProps {
  vertical?: true
  className?: string
}
export const Divider = ({ vertical, className }: DividerProps) => {
  return (
    <div className={clsx(className, vertical ? s.vertical : s.horizontal)} />
  )
}
